export default __webpack_public_path__ + "static/media/batch-apply-submit-bg.c3eb1d36.svg";